import { useMemo } from 'react';

/**
 * Memoize an object before passing it as the `value` to a context provider.
 * This isn't always necessary, but it's a good idea if the component rendering
 * the provider renders frequently.
 *
 * @param value context value object
 *
 * @returns memoized context value object
 */
export const useMemoContextValue = <T extends object>(
  value: T,
  // eslint-disable-next-line react-hooks/exhaustive-deps
): T => useMemo(() => value, Object.values(value));
